import type { ApplyRequestsMapperT } from "../types/applyRequests.types";

const APPLIED_OK_STATUS = "OK";

export const applyRequestsMapper: ApplyRequestsMapperT = {
  toApplyRequestsDto: (requests) => {
    return {
      requests: requests.map((requestId) => ({ requestId })),
    };
  },
  applyRequestsDtoToDomain: (rawData) => {
    const rawResults = Array.isArray(rawData.results) ? rawData.results : [];

    return {
      count: rawData.count ?? rawResults.length,
      results: rawResults.map((item) => ({
        requestId: item.requestId,
        status: item.status,
        isSuccess: item.status === APPLIED_OK_STATUS,
      })),
    };
  },
};
